import * as React from "react";
import { Path, G, ClipPath, Defs, Rect } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const MGIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="MG" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#78D843"
        fillRule="evenodd"
        d="M5.6 6H16v6H5.6V6Z"
        clipRule="evenodd"
      />
      <Path
        fill="#EA1A1A"
        fillRule="evenodd"
        d="M5.6 0H16v6H5.6V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#F7FCFF"
        fillRule="evenodd"
        d="M0 0h6.4v12H0V0Z"
        clipRule="evenodd"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
